const ORGANIZATION_TYPE_JF_OPTIONS = [
   {
      value: 'DE',
      label: 'DE',
      id: 'DE',
      name: 'DE',
   },
   {
      value: 'JF',
      label: 'JF',
      id: 'JF',
      name: 'JF',
   },
];

export default ORGANIZATION_TYPE_JF_OPTIONS;
